import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "@/components/layout/Layout";
import UnifiedLoginView from "@/views/UnifiedLoginView.vue";
import POSView from "@/views/point-of-sale/POSView.vue";
import MobilePOSView from "@/views/point-of-sale/MobilePOSView.vue";
import FloatView from "@/views/point-of-sale/floatCashup/FloatView";
import AllTablesView from "@/views/point-of-sale/tables/AllTablesView";
import SelectCustomerView from "@/views/point-of-sale/Accounts/SelectCustomerView.vue";
import PaymentView from "@/views/point-of-sale/payment/PaymentView";
import SplitPaymentView from "@/views/point-of-sale/payment/SplitPaymentView";
import ViewInvoicesView from "@/views/point-of-sale/payment/ViewInvoicesView";
import SmartLodgingView from "@/views/point-of-sale/SmartLodgingView.vue";
import OtpView from "@/views/OtpView.vue";
import store from "@/store";
import { Storage } from "@/services/Storage";
import { useAppUsage } from '@/composables/useAppUsage';

Vue.use(VueRouter)

// Mobile device detection helper
const isMobileDevice = () => {
    // Check if running in Electron - ALWAYS return false for desktop app
    const isElectron = window && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('Electron') > -1;
    if (isElectron) return false;

    const width = window.innerWidth;
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

    // Check if running in Capacitor (mobile app)
    const isCapacitor = window.Capacitor !== undefined;

    return width < 768 || isMobileUA || isCapacitor;
};

const routes = [
    {
        path: '/',
        name: "poslogin",
        component: UnifiedLoginView,
    },
    {
        path: '/customer-display',
        name: "customer-display",
        component: () => import('@/views/customer/CustomerDisplayView.vue'),
    },
    {
        path: '/OTP',
        name: "OtpView",
        component: OtpView,
    },
    {
        path: '/select-subscription-type',
        name: "select-subscription-type",
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "payment" */ '../views/setup/SelectSubscriptionType')
    },
    {
        path: '/pos',
        name: 'pos',
        component: POSView,
        beforeEnter: (to, from, next) => {
            // Automatically redirect mobile devices to mobile POS view
            if (isMobileDevice()) {
                next({ name: 'mobile-pos', query: to.query, replace: true });
            } else {
                next();
            }
        }
    },
    {
        path: '/mobile-pos',
        name: 'mobile-pos',
        component: MobilePOSView,
    },
    {

        path: '/',
        component: Layout,
        children: [
            {
                path: '/payment',
                name: "payment",
                component: PaymentView,
            },
            {
                path: '/Ticket',
                name: 'Create-Ticket',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "create-ticket" */ '../views/Tickets/Ticket.vue'),
            },
            {
                path: '/ViewOpenTicket',
                name: 'ViewOpenTicket',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "SystemAdjustments" */ '../views/Tickets/ViewOpenTicket.vue'),
            },
            {
                path: '/loyalty-customers',
                name: "loyalty-customers",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "loyalty-customers" */ '../views/point-of-sale/Loyalty/LoyaltyCustomers'),
            },
            {
                path: '/ViewClosedTicket',
                name: 'ViewClosedTicket',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "ViewClosedTicket" */ '../views/Tickets/ViewClosedTicket.vue'),
            },
            {
                path: '/ticket/:id',
                name: 'TicketDetail',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "TicketDetail" */ '../views/Tickets/TicketDetails.vue'),
                // component: TicketDetail,
            },

            {
                path: '/split-payment',
                name: "split-payment",
                component: SplitPaymentView,
            },
            {
                path: '/view-payment',
                name: "viewPayment",
                component: ViewInvoicesView
            },
            {
                path: '/float',
                name: "float",
                component: FloatView,
            },
            {
                path: '/PrecashUps',
                name: "PrecashUps",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "float" */ '../views/PrecashUps.vue'),
            },
            {
                path: '/instruction',
                props: true,
                name: "instruction",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "float" */ '../views/point-of-sale/cookingInstruction/CookingInstruction'),
            },
            {
                path: '/cashup',
                name: "cashup",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "cashup" */ '../views/point-of-sale/floatCashup/CashupView.vue'),
            },

            {
                path: '/cashup-records',
                name: "cashup-records",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "cashup-records" */ '../views/point-of-sale/floatCashup/CashupRecordsView.vue'),
            },

            {
                path: '/sales-records',
                name: "salesRecords",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "salesRecords" */ '../views/point-of-sale/SalesRecordsView'),
            },
            {
                path: '/settings',
                name: "settings",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "settings" */ '../views/boffice/settings/SettingsView'),
            },
            {
                path: '/table-server-config',
                name: "main-table-server-config",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "settings" */ '../views/boffice/settings/TableServerSettings.vue'),
            },
            {
                path: '/table-server-logs',
                name: "table-server-logs",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "settings" */ '../views/boffice/settings/TableServerLogsView.vue'),
            },

            {
                path: '/view-invoice/:invoice',
                name: "viewInvoice",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "viewInvoice" */ '../views/point-of-sale/InvoiceDetailsView'),
            },

            {
                path: '/refund-invoice/:invoice',
                name: "refundInvoice",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "refundInvoice" */ '../views/point-of-sale/RefundInvoiceView'),
            },

            {
                path: '/tables',
                name: "tables",
                component: AllTablesView,
            },
            {
                path: '/kitchen-orders',
                name: "kitchen-orders",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "kitchen-orders" */ '../views/point-of-sale/tables/KitchenOrdersView'),
            },
            {
                path: '/create-table',
                name: "create-table",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "create-table" */ '../views/point-of-sale/tables/CreateTableView'),
            },

            {
                path: '/select-customer',
                name: "select-customer",
                component: SelectCustomerView,
            },

            {
                path: '/create-debtor',
                name: "create-debtor",
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "create-debtor" */ '../views/point-of-sale/Accounts/CreateDebtorView'),
            },

            {
                path: '/subscription-accounts',
                name: 'subscription-accounts',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "subscription-accounts" */ '../views/setup/Expired/SubscriptionsAndAccountsView'),
            },
            {
                path: '/merge-tables',
                name: 'merge-tables',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "merge-tables" */ '../views/point-of-sale/tables/MergeTables'),
            },
            {
                path: '/split-table',
                name: 'split-table',
                component: () => import(/* webpackPrefetch: true  , webpackChunkName: "split-table" */ '../views/point-of-sale/tables/SplitTableView'),
            },
            {
                path: '/StockRecords',
                name: "StockRecords",
                component: () => import(/* webpackChunkName: "stock-take" */ '../views/boffice/StockTake/StockRecords'),
            },

            {
                path: '/stock-take',
                name: "stock-take",
                component: () => import(/* webpackChunkName: "stock-take" */ '../views/boffice/StockTake/StockTakeListView'),
            },

            {
                path: '/run-stock-take',
                name: "run-stock-take",
                component: () => import(/* webpackChunkName: "run-stock-take" */ '../views/boffice/StockTake/StockTakeItemsView'),
            },

            {
                path: '/stock-transfer',
                name: 'stock-transfer',
                component: () => import(/* webpackChunkName: "stock-transfer" */ '../views/boffice/stock-transfer/SelectTransferTypeView'),
            },
            {
                path: '/select-receiving-store',
                name: 'select-receiving-store',
                component: () => import(/* webpackChunkName: "stock-transfer" */ '../views/boffice/stock-transfer/SelectReceivingStoreView'),
            },
            {
                path: '/search-items-to-send',
                name: 'search-items-to-send',
                component: () => import(/* webpackChunkName: "stock-transfer" */ '../views/boffice/stock-transfer/SearchItemsToSendView'),
            },
            {
                path: '/view-items-to-send',
                name: 'view-items-to-send',
                component: () => import(/* webpackChunkName: "stock-transfer" */ '../views/boffice/stock-transfer/ViewItemsToSendView'),
            },
            {
                path: '/incoming-stock-transfer',
                name: 'incoming-stock-transfer',
                component: () => import(/* webpackChunkName: "stock-transfer" */ '../views/boffice/stock-transfer/IncomingTransfersView'),
            },
            {
                path: '/view-incoming-transfer',
                name: 'view-incoming-transfer',
                component: () => import(/* webpackChunkName: "stock-transfer" */ '../views/boffice/stock-transfer/ViewIncomingTransferView'),
            },
            {
                path: '/saved-stock-transfer',
                name: 'saved-stock-transfer',
                component: () => import(/* webpackChunkName: "stock-transfer" */ '../views/boffice/stock-transfer/SavedTransfersView'),
            },
            {
                path: '/not-received-transfer',
                name: 'not-received-transfer',
                component: () => import(/* webpackChunkName: "stock-transfer" */ '../views/boffice/stock-transfer/NotReceivedTransfersView'),
            },
            {
                path: '/rejected-stock-transfer',
                name: 'rejected-stock-transfer',
                component: () => import(/* webpackChunkName: "stock-transfer" */ '../views/boffice/stock-transfer/RejectedTransfersView'),
            },
            {
                path: '/offline-invoices',
                name: "offline-invoices",
                component: () => import(/* webpackChunkName: "offline-invoices" */ '../views/point-of-sale/payment/OfflineInvoicesView.vue'),
            },

            {
                path: '/online-orders',
                name: "online-orders",
                component: () => import(/* webpackChunkName: "online-orders" */ '../views/orders/OnlineOrdersView.vue'),
            },

            {
                path: '/smart-lodging',
                name: "smart-lodging",
                component: SmartLodgingView,
            },

            {
                path: '/help',
                name: 'help',
                component: () => import(/* webpackChunkName: "help" */ '../views/Help/HelpView.vue'),
            },
            {
                // In-app update flow. See docs/exec-plans/active/2026-06-23-app-update-flow.md.
                path: '/updates',
                name: 'updates',
                component: () => import(/* webpackChunkName: "updates-view" */ '../views/UpdatesView.vue'),
            },

        ]
    },

    {
        path: '/email-settings',
        name: "email-settings",
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "email-settings" */ '../views/boffice/settings/EmailSetupView'),
    },

    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "Login"*/ '../views/LoginView.vue'),
    },
    {
        path: '/setup',
        name: 'setup',
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "setup"*/ '../views/setup/AppSetupLogin.vue')
    },

    {
        path: '/SelectUserView',
        name: 'SelectUserView',
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "setup"*/ '../views/SelectUserView.vue')
    },

    {
        path: '/system-expired',
        name: 'system-expired',
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "system-expired"*/ '../views/setup/Expired/SystemExpired')
    },

    {
        path: '/make-subscription-payment',
        name: 'make-subscription-payment',
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "make-subscription-payment"*/ '../views/setup/Expired/MonthlyPaymentView')
    },

    {
        path: '/expire-extension',
        name: 'expire-extension',
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "expire-extension"*/ '../views/setup/Expired/ExtensionSuccess')
    },

    {
        path: '/validation',
        name: 'validation',
        component: () => import(/* webpackPrefetch: true, webpackChunkName: "validation" */ '../views/ValidationView.vue')
    },

    {
        path: '*',
        name: "notfound",
        component: () => import(/* webpackPrefetch: true  , webpackChunkName: "payment-view" */ '../views/point-of-sale/PosLoginView.vue')
    },

]

// Detect if running on file:// protocol (Electron) and use hash mode
// Otherwise use history mode for web browsers
const isElectron = window && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('Electron') > -1;
const isFileProtocol = window.location && window.location.protocol === 'file:';

const routerMode = (isElectron || isFileProtocol) ? 'hash' : 'history';

const router = new VueRouter({
    mode: routerMode,
    base: process.env.BASE_URL,
    routes,
    // Ensure scroll behavior works properly
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
})
window.popStateDetected = false
window.addEventListener('popstate', () => {
    window.popStateDetected = true
})


// Handle NavigationDuplicated errors silently
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (
            err.name !== 'NavigationDuplicated' &&
            (!err.message || !err.message.startsWith('Redirected'))
        ) throw err
    })
}

// Also handle replace method to prevent NavigationDuplicated errors
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => {
        if (
            err.name !== 'NavigationDuplicated' &&
            (!err.message || !err.message.startsWith('Redirected'))
        ) throw err
    })
}

router.beforeEach(async (to, from, next) => {
    // App Usage Tracking: Record page views (only for authenticated users)
    // Use queueEvent for batching - reduces API calls significantly
    try {
        const { setUser, queueEvent } = useAppUsage()

        // Get current user from store (Vuex module)
        const currentUser = store.getters.getCurrentUser
        const isAuthenticated = currentUser && (currentUser.UserID || currentUser.id) &&
            currentUser.Username && String(currentUser.Username).trim().length > 0

        // Only track page views for authenticated users (after hydration)
        if (store.getters.isHydrated && isAuthenticated) {
            const userId = currentUser.UserID || currentUser.id
            setUser(userId)

            // Queue event for batch processing (not immediate API call)
            if (to.name) {
                queueEvent('page:' + to.name, 'view')
            }
        }
    } catch (e) {
        // Silently ignore tracking errors - should not affect navigation
    }

    if (!store.getters.isHydrated) {
        await new Promise((resolve) => {
            const interval = setInterval(() => {
                if (store.getters.isHydrated) {
                    clearInterval(interval);
                    resolve();
                }
            }, 50);  // Check every 50ms
        });
    }

    let exceptions = routeExceptions;
    if (exceptions.includes(to.name)) {
        next();
    } else {
        if (!exceptions.includes(to.name)) {

            let res = await auth.isAdminLoggedIn()
            let storeDB = !!(await Storage.getCurrentStoreDB());
            let currentUser = store.getters.getCurrentUser;
            let userauth = !!(currentUser && currentUser.Username)

            // Allow setup/poslogin/validation while franchise is logged in but no cashier
            // (Switch Store lands on setup with admin still present and store unbound).
            if (res && !userauth && storeDB && to.name !== 'poslogin' && to.name !== 'validation' && to.name !== 'setup' && to.name !== 'system-expired' && to.name !== 'make-subscription-payment') {
                next({ name: 'poslogin' })
            } else if (!res && !storeDB) {
                if (to.name === 'poslogin' || to.name === 'login' || to.name === 'setup') return next();
                next({ name: 'login' })
            } else {
                const IsItABackButton = window.popStateDetected
                window.popStateDetected = false
                if (IsItABackButton && from.name === `system-expired`) {
                    next(false)
                    return responses.showWarning(`System Expired`)
                }
                next()
            }
        } else {
            next()
        }
    }
})


export default router
